import {MuWidget} from "mu-widget/lib/MuWidget";
import {BaseModule} from "./BaseModule";
import {formGroup} from "./BaseEditor";

export abstract class UiBaseFilter extends MuWidget
{
	// @ts-ignore
	public getFilter: () => any;
	// @ts-ignore
	public setFilter: (filter: any) => void;

	wrapFilter(src: string) {
		this.muAppendContent(
			'<div mu-id="searchFields">' + src + `</div><div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zrušit filtr</span>
			</div>`
		);

	}

	afterIndex() {
		this.muBindData(this.getFilter());
	}

	showByField(field: string|null): HTMLElement[] {
		const res = [];
		// @ts-ignore
		for(const el of this.ui.searchFields.children) {
			const vis = !field || (field == el.dataset.field);
			el.style.display = vis
				? ""
				: "none";
			if (vis) res.push(el);
		}
		this.muVisible(!field, 'bClearFilter');

		return res;
	}

	bFilter_click() {
		this.setFilter(this.muFetchData());
		this.muRemoveSelf();
	}

	bClearFilter_click() {
		this.setFilter({});
		this.muRemoveSelf();
	}

	eraseFilterField(ev: any, field: string) {
		this.muBindData({ [field]: null });
	}

	muFetchData(): any {
		const filter = super.muFetchData();
		for(const k in filter) {
			// prázdný seznam - nefiltruje se
			if (Array.isArray(filter[k]) && filter[k].length === 0) filter[k] = null;
		}
		return filter;
	}
}
